module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0009.jpg?v=e51d0713";